var render = function render(){var _vm=this,_c=_vm._self._c;return _c('menu-lateral',{attrs:{"auto-folded":false,"folded":true,"menu":_vm.menu,"full-height":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }